function assertContainerElement(element: HTMLElement | null | undefined): asserts element is HTMLElement {
   if (!element) {
      throw new Error("Container element not found");
   }
}

export default assertContainerElement;